// extracted by mini-css-extract-plugin
module.exports = {"toolboxbtn":"ToolboxPane_toolboxbtn__2Ee38","subtitle":"ToolboxPane_subtitle__1wdAJ"};